import script from "./navbar.vue?vue&type=script&setup=true&lang=js"
export * from "./navbar.vue?vue&type=script&setup=true&lang=js"

import "./navbar.vue?vue&type=style&index=0&id=88b4607a&lang=css"

const __exports__ = script;

export default __exports__